/**
 * Quick Order by SKU — Alliance Chemical
 * SKU paste, CSV upload, autocomplete search, multi-item cart add
 *
 * NOTE: All product data is server-rendered by Liquid from the Shopify catalog.
 * No user-generated content is rendered as HTML — all dynamic content uses
 * textContent or pre-sanitized Shopify product data (title, SKU, price, image URL).
 */
(function() {
  'use strict';

  // Product data loaded via AJAX into window.qoProducts
  var products = window.qoProducts || [];
  var orderItems = []; // { variantId, sku, title, variant, price, image, qty, available }

  // Re-bind products reference once AJAX load completes
  document.addEventListener('qo:products-loaded', function() {
    products = window.qoProducts || [];
  });

  // DOM refs
  var orderBody = document.getElementById('qo-order-body');
  var emptyState = document.getElementById('qo-empty');
  var listSection = document.getElementById('qo-list-section');
  var itemCount = document.getElementById('qo-item-count');
  var subtotalEl = document.getElementById('qo-subtotal');
  var addAllBtn = document.getElementById('qo-add-all');
  var notice = document.getElementById('qo-notice');

  // === SAFE DOM HELPERS ===
  // All rendered content comes from Shopify's product catalog (server-rendered JSON).
  // We use DOM creation methods rather than string concatenation for safety.
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  // === TAB SWITCHING ===
  var tabs = document.querySelectorAll('.qo__tab');
  var panes = document.querySelectorAll('.qo__pane');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(t) { t.classList.remove('qo__tab--active'); });
      panes.forEach(function(p) { p.classList.remove('qo__pane--active'); });
      tab.classList.add('qo__tab--active');
      document.getElementById('qo-pane-' + tab.dataset.pane).classList.add('qo__pane--active');
    });
  });

  // === SKU LOOKUP ===
  function findBySku(sku) {
    sku = sku.trim().toUpperCase();
    for (var i = 0; i < products.length; i++) {
      if (products[i].sku && products[i].sku.toUpperCase() === sku) return products[i];
    }
    return null;
  }

  function parsePositiveQty(value) {
    var n = parseInt(value, 10);
    return n > 0 ? n : 1;
  }

  function parseSkuEntry(entry) {
    var cleaned = (entry || '').trim();
    if (!cleaned) return null;

    var match = cleaned.match(/^([A-Za-z0-9\-_.]+)(?:\s*(?:x|\u00d7|,)\s*(\d+))?$/i);
    if (!match) return null;

    return {
      sku: match[1],
      qty: parsePositiveQty(match[2])
    };
  }

  function tokenizeSkuEntries(raw) {
    var chunks = raw.split(/\r?\n|;/).map(function(chunk) {
      return chunk.trim();
    }).filter(Boolean);
    var entries = [];

    chunks.forEach(function(chunk) {
      var directEntry = parseSkuEntry(chunk);
      if (directEntry) {
        entries.push(directEntry);
        return;
      }

      var tokens = chunk.split(',').map(function(token) {
        return token.trim();
      }).filter(Boolean);

      if (!tokens.length) return;

      for (var i = 0; i < tokens.length; i++) {
        var current = tokens[i];
        var next = tokens[i + 1];

        if (/^[A-Za-z0-9\-_.]+$/i.test(current) && /^\d+$/.test(next || '')) {
          entries.push(parseSkuEntry(current + ', ' + next));
          i++;
          continue;
        }

        var parsedToken = parseSkuEntry(current);
        if (parsedToken) entries.push(parsedToken);
        else entries.push({ invalid: current });
      }
    });

    return entries;
  }

  // === ADD ITEM ===
  function addItem(product, qty) {
    qty = parsePositiveQty(qty);
    var existing = orderItems.find(function(item) { return item.variantId === product.variantId; });
    if (existing) {
      existing.qty += qty;
      renderOrder();
      showNotice('Merged duplicate: ' + product.sku + ' (qty now ' + existing.qty + ')', 'info');
      return;
    }
    orderItems.push({
      variantId: product.variantId,
      sku: product.sku,
      title: product.title,
      variant: product.variant,
      price: product.price,
      image: product.image,
      qty: qty,
      available: product.available
    });
    renderOrder();
  }

  // === RENDER ORDER TABLE (DOM-based, no innerHTML with dynamic data) ===
  function renderOrder() {
    orderBody.textContent = ''; // clear

    if (orderItems.length === 0) {
      emptyState.style.display = 'block';
      listSection.querySelector('.qo__footer').style.display = 'none';
      itemCount.textContent = '0 items';
      return;
    }
    emptyState.style.display = 'none';
    listSection.querySelector('.qo__footer').style.display = 'flex';

    var totalItems = 0;
    var subtotal = 0;

    orderItems.forEach(function(item, idx) {
      var lineTotal = item.price * item.qty;
      totalItems += item.qty;
      if (item.available) subtotal += lineTotal;

      var tr = document.createElement('tr');

      // Product cell
      var tdProd = document.createElement('td');
      var prodCell = el('div', 'qo__prod-cell');
      if (item.image) {
        var img = document.createElement('img');
        img.className = 'qo__prod-img';
        img.src = item.image;
        img.alt = '';
        prodCell.appendChild(img);
      }
      var infoDiv = document.createElement('div');
      var nameDiv = el('div', 'qo__prod-name', item.title);
      if (!item.available) {
        var badge = el('span', 'qo__oos-badge', 'Out of Stock');
        nameDiv.appendChild(badge);
      }
      infoDiv.appendChild(nameDiv);
      infoDiv.appendChild(el('div', 'qo__prod-variant', item.variant));
      infoDiv.appendChild(el('div', 'qo__prod-sku', item.sku));
      prodCell.appendChild(infoDiv);
      tdProd.appendChild(prodCell);
      tr.appendChild(tdProd);

      // Price
      tr.appendChild(el('td', '', '$' + item.price.toFixed(2)));

      // Quantity controls
      var tdQty = document.createElement('td');
      var qtyCtrl = el('div', 'qo__qty-ctrl');
      var minusBtn = el('button', 'qo__qty-btn', '-');
      minusBtn.addEventListener('click', function() { orderItems[idx].qty = Math.max(1, orderItems[idx].qty - 1); renderOrder(); });
      var qtyInput = document.createElement('input');
      qtyInput.className = 'qo__qty-val';
      qtyInput.type = 'text';
      qtyInput.inputMode = 'numeric';
      qtyInput.pattern = '[0-9]*';
      qtyInput.value = String(item.qty);
      qtyInput.setAttribute('aria-label', 'Quantity for ' + item.sku);
      qtyInput.autocomplete = 'off';
      qtyInput.addEventListener('input', function() {
        qtyInput.value = qtyInput.value.replace(/[^\d]/g, '').slice(0, 5);
      });
      function commitQtyChange() {
        orderItems[idx].qty = parsePositiveQty(qtyInput.value);
        renderOrder();
      }
      qtyInput.addEventListener('change', commitQtyChange);
      qtyInput.addEventListener('blur', commitQtyChange);
      qtyInput.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          commitQtyChange();
        }
      });
      var plusBtn = el('button', 'qo__qty-btn', '+');
      plusBtn.addEventListener('click', function() { orderItems[idx].qty++; renderOrder(); });
      qtyCtrl.appendChild(minusBtn);
      qtyCtrl.appendChild(qtyInput);
      qtyCtrl.appendChild(plusBtn);
      tdQty.appendChild(qtyCtrl);
      tr.appendChild(tdQty);

      // Line total
      tr.appendChild(el('td', 'qo__line-total', '$' + lineTotal.toFixed(2)));

      // Remove button
      var tdRemove = document.createElement('td');
      var removeBtn = el('button', 'qo__remove', '\u00d7');
      removeBtn.title = 'Remove';
      removeBtn.addEventListener('click', function() { orderItems.splice(idx, 1); renderOrder(); });
      tdRemove.appendChild(removeBtn);
      tr.appendChild(tdRemove);

      orderBody.appendChild(tr);
    });

    itemCount.textContent = totalItems + ' item' + (totalItems !== 1 ? 's' : '');
    subtotalEl.textContent = '';
    subtotalEl.appendChild(document.createTextNode('Subtotal: '));
    var strong = document.createElement('strong');
    strong.textContent = '$' + subtotal.toFixed(2);
    subtotalEl.appendChild(strong);

    var hasAvailable = orderItems.some(function(i) { return i.available; });
    addAllBtn.disabled = !hasAvailable;
  }

  // === SKU PASTE HANDLER ===
  document.getElementById('qo-parse-skus').addEventListener('click', function() {
    var raw = document.getElementById('qo-sku-input').value.trim();
    if (!raw) return;
    var added = 0, notFound = [], skipped = 0;

    tokenizeSkuEntries(raw).forEach(function(entry) {
      if (!entry || entry.invalid) {
        skipped++;
        return;
      }

      var sku = entry.sku;
      var qty = entry.qty;
      var product = findBySku(sku);
      if (product) { addItem(product, qty); added++; }
      else { notFound.push(sku); }
    });

    var msg = added + ' item(s) added.';
    if (notFound.length) msg += ' Not found: ' + notFound.join(', ');
    if (skipped) msg += ' ' + skipped + ' row(s) skipped.';
    showNotice(msg, notFound.length ? 'error' : 'success');
    document.getElementById('qo-sku-input').value = '';
  });

  // === CSV UPLOAD ===
  document.getElementById('qo-csv-input').addEventListener('change', function(e) {
    var file = e.target.files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function(ev) {
      var text = ev.target.result;
      var rows = text.split(/\r?\n/).slice(1).filter(Boolean);
      var added = 0, notFound = [], skipped = 0;
      rows.forEach(function(row) {
        var cols = row.split(',').map(function(c) { return c.trim().replace(/^"|"$/g, ''); });
        var sku = cols[0];
        var qty = parseInt(cols[1]) || 1;
        if (!sku) { skipped++; return; }
        var product = findBySku(sku);
        if (product) { addItem(product, qty); added++; }
        else { notFound.push(sku); }
      });
      var msg = added + ' item(s) added from CSV.';
      if (notFound.length) msg += ' Not found: ' + notFound.join(', ');
      if (skipped) msg += ' ' + skipped + ' row(s) skipped.';
      showNotice(msg, notFound.length ? 'error' : 'success');
    };
    reader.readAsText(file);
    e.target.value = '';
  });

  // CSV template download
  document.getElementById('qo-download-tpl').addEventListener('click', function(e) {
    e.preventDefault();
    var csv = 'SKU,Quantity\nEXAMPLE-SKU-1,2\nEXAMPLE-SKU-2,1\n';
    var blob = new Blob([csv], { type: 'text/csv' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url; a.download = 'quick-order-template.csv'; a.click();
    URL.revokeObjectURL(url);
  });

  // === AUTOCOMPLETE SEARCH ===
  var searchInput = document.getElementById('qo-search');
  var acDropdown = document.getElementById('qo-autocomplete');
  var debounceTimer;

  searchInput.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    var q = searchInput.value.toLowerCase().trim();
    if (q.length < 2) { acDropdown.style.display = 'none'; return; }
    debounceTimer = setTimeout(function() {
      var results = products.filter(function(p) {
        return (p.title + ' ' + p.variant + ' ' + p.sku).toLowerCase().indexOf(q) !== -1;
      }).slice(0, 8);

      acDropdown.textContent = '';
      if (results.length === 0) { acDropdown.style.display = 'none'; return; }

      results.forEach(function(p) {
        var row = el('div', 'qo__ac-item');
        row.dataset.vid = p.variantId;
        if (p.image) {
          var img = document.createElement('img');
          img.className = 'qo__ac-img';
          img.src = p.image;
          img.alt = '';
          row.appendChild(img);
        }
        var info = el('div', 'qo__ac-info');
        info.appendChild(el('div', 'qo__ac-name', p.title + ' \u2014 ' + p.variant));
        info.appendChild(el('div', 'qo__ac-sku', p.sku));
        row.appendChild(info);
        row.appendChild(el('div', 'qo__ac-price', '$' + p.price.toFixed(2)));
        acDropdown.appendChild(row);
      });
      acDropdown.style.display = 'block';
    }, 200);
  });

  acDropdown.addEventListener('click', function(e) {
    var item = e.target.closest('.qo__ac-item');
    if (!item) return;
    var vid = parseInt(item.dataset.vid);
    var product = products.find(function(p) { return p.variantId === vid; });
    if (product) { addItem(product, 1); }
    searchInput.value = '';
    acDropdown.style.display = 'none';
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('.qo__search-wrap')) acDropdown.style.display = 'none';
  });

  // === ADD ALL TO CART ===
  addAllBtn.addEventListener('click', function() {
    var items = orderItems.filter(function(i) { return i.available; }).map(function(i) {
      return { id: i.variantId, quantity: i.qty };
    });
    if (items.length === 0) return;

    addAllBtn.disabled = true;
    addAllBtn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.items) {
        var added = data.items.length;
        var failed = items.length - added;
        var msg = added + ' item(s) added to cart!';
        if (failed > 0) msg += ' ' + failed + ' item(s) failed.';
        showNotice(msg, failed ? 'error' : 'success');

        var addedIds = data.items.map(function(i) { return i.variant_id; });
        orderItems = orderItems.filter(function(i) { return !addedIds.includes(i.variantId); });
        renderOrder();

        // Refresh header cart UI. This theme surfaces the cart total via
        // [data-header-cart-total]; count-badge variants use [data-header-cart-count].
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          if (window.Shopify && typeof Shopify.formatMoney === 'function') {
            document.querySelectorAll('[data-header-cart-total]').forEach(function(el) {
              el.textContent = Shopify.formatMoney(cart.total_price, '${{amount}}');
              el.classList.remove('hidden');
            });
          }
          document.querySelectorAll('[data-header-cart-count], .cart-count, .cart-count-bubble span, [data-cart-count]').forEach(function(el) {
            el.textContent = cart.item_count;
            el.classList.remove('hidden');
          });
        });
      } else {
        showNotice('Error adding to cart. Please try again.', 'error');
      }
    })
    .catch(function() {
      showNotice('Network error. Please try again.', 'error');
    })
    .finally(function() {
      addAllBtn.disabled = false;
      addAllBtn.textContent = 'Add All to Cart';
    });
  });

  // === NOTICE ===
  function showNotice(msg, type) {
    notice.textContent = msg;
    notice.className = 'qo__notice qo__notice--' + type;
    notice.style.display = 'block';
    setTimeout(function() { notice.style.display = 'none'; }, 6000);
  }

  // Initial render
  renderOrder();
})();
